import React, { useState, useEffect } from "react";
import uiData from "./data.json";
import { api } from "../../api/apiConfig";
import { useNavigate } from "react-router-dom";

const OpenStockEntry = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    box_id: "",
    party_id: "",
    crate_count: "",
  });
  const [entries, setEntries] = useState([]);
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    fetchEntries();
  }, []);

  const fetchEntries = async () => {
    try {
      const res = await api.get("/stock_report");
      if (res.data.success) setEntries(res.data.data);
    } catch (error) {
      console.error("Error fetching open stock entries:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    try {
      if (!formData.box_id || !formData.party_id || !formData.crate_count) {
        alert("Please fill all fields");
        return;
      }

      if (editId) {
        await api.put(`/stock_report/${editId}`, formData);
      } else {
        await api.post("/stock_report", formData);
      }

      await fetchEntries();
      handleCancel();
    } catch (err) {
      console.error("Error saving data:", err);
    }
  };

  const handleEdit = (entry) => {
    setFormData({
      box_id: entry.box_id,
      party_id: entry.party_id,
      crate_count: entry.crate_count,
    });
    setEditId(entry.id);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this entry?")) return;
    try {
      await api.delete(`/stock_report/${id}`);
      fetchEntries();
    } catch (err) {
      console.error("Error deleting entry:", err);
    }
  };

  const handleCancel = () => {
    setFormData({ box_id: "", party_id: "", crate_count: "" });
    setEditId(null);
  };

  const handleExit = () => {
    navigate("/dashboard");
  };

  return (
    <div className="w-full h-full box-border bg-red-500">
      <div className="min-h-screen bg-[#eadacd] border-[4px] border-black p-[6px] box-border">
        <div className="h-full border-[2px] border-black flex flex-col bg-[#eadacd] box-border">
          <div className="flex items-center justify-center h-[20px] bg-[#d5beb0] border-b-[2px] border-black text-[10px] sm:text-[12px] font-semibold shadow-inner text-center">
            Sorathiya Software Amreli 99794 77751 - 25/08/2025
          </div>

          <div className="flex flex-col md:flex-row gap-2 px-2 py-2 items-stretch">
            <div className="flex-1 flex flex-col justify-center bg-[#efe0c6] border-[2px] border-black p-2 text-center">
              <div className="font-bold text-[16px] sm:text-[18px]">
                Jalaram Vegetable Co - 2
              </div>
              <div className="text-[12px] sm:text-[13px] mt-1">
                Fruit - Vegetable Merchant & Commission Agent
              </div>
              <div className="text-[12px] sm:text-[13px]">Phone : 9824185221</div>
            </div>

            <div className="flex-1 hidden lg:flex flex-col justify-center bg-[#efe0c6] border-[2px] border-black pl-4 text-center lg:text-left">
              <div>
                <div className="font-extrabold text-[18px] sm:text-[20px] leading-none">
                  Crate Open Entry
                </div>
                <div className="text-[12px] sm:text-[13px] mt-1">
                  Open Stock Entry
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col lg:flex-row w-full px-2 pb-2 gap-2 flex-1">
            <div className="lg:w-1/2 border-[2px] border-black p-3 bg-[#efe0c6] box-border">
              {uiData.formFields.map((field, i) => (
                <div key={i} className="mb-3 flex flex-col sm:flex-row sm:px-10">
                  <div className="sm:w-[30%] pr-2">
                    <div className="font-bold text-[13px] sm:text-[14px]">{field.label}</div>
                  </div>
                  <div className="flex w-full mt-1 sm:mt-0">
                    {field.type === "select" ? (
                      <select
                        name={field.name}
                        value={formData[field.name]}
                        onChange={handleChange}
                        className={`w-full rounded text-sm ${field.bg} border-[2px] border-black px-2 py-[6px] shadow-inner`}
                      >
                        <option value="">-- Select --</option>
                        {field.options?.map((opt, idx) => (
                          <option key={idx} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <input
                        name={field.name}
                        type="text"
                        value={formData[field.name]}
                        onChange={handleChange}
                        className={`w-full rounded text-sm ${field.bg} border-[2px] border-black px-2 py-[6px] shadow-inner`}
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>

            <div className="lg:w-1/2 box-border">
              <div className="border-[2px] border-black min-h-[250px] w-full bg-white flex flex-col">
                <div className="bg-[#e6e6e6] border-b-[2px] border-black p-[6px] text-center font-bold grid grid-cols-[1fr_1fr_80px_80px] text-[12px] sm:text-[13px]">
                  <div className="border-r border-black">Party ID</div>
                  <div className="border-r border-black">Box ID</div>
                  <div className="border-r border-black">Count</div>
                  <div>Action</div>
                </div>

                <div className="overflow-y-auto p-1 max-h-[300px]">
                  <table className="w-full border-collapse text-[12px] sm:text-[13px]">
                    <tbody>
                      {entries.map((entry) => (
                        <tr key={entry.id}>
                          <td className="border-b border-[#c8c8c8] px-2 py-[6px]">
                            {entry.party_id}
                          </td>
                          <td className="border-b border-[#c8c8c8] px-2 py-[6px]">
                            {entry.box_id}
                          </td>
                          <td className="border-b border-[#c8c8c8] px-2 py-[6px] text-right">
                            {entry.crate_count}
                          </td>
                          <td className="border-b border-[#c8c8c8] px-2 py-[6px] text-center">
                            <button
                              onClick={() => handleEdit(entry)}
                              className="px-2 py-[2px] bg-[#e0d3a4] border border-black rounded mr-2 hover:bg-[#d9c889]"
                            >
                              Edit
                            </button>
                            <button
                              onClick={() => handleDelete(entry.id)}
                              className="px-2 py-[2px] bg-[#f4b2a4] border border-black rounded hover:bg-[#e7a395]"
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-3 p-2 border-t-[2px] border-black bg-[#c9b6a3]">
            {[
              { label: "AddNew", action: () => handleCancel() },
              { label: "Save", action: handleSave },
              { label: "Cancel", action: handleCancel },
              { label: "Exit", action: handleExit },
            ].map((btn, i) => (
              <button
                key={btn.label}
                onClick={btn.action}
                className={`min-w-[70px] sm:min-w-[80px] px-3 py-2 border-[2px] border-[#5b4a3d] bg-[#f0d7c1] font-bold text-sm shadow-[2px_2px_0_rgba(0,0,0,0.55)] hover:bg-[#e7c9b2] active:shadow-inner`}
              >
                {btn.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OpenStockEntry;
